import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseReviewPanel } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/courses/$courseId/review")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseReviewPanel />
    </RouteGuard>
  ),
});
